export const DESIGNS = {
  COMPRESSED: 'compressed',
  SPACED: 'spaced'
}
